import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from '../views/LoginPage/LoginPage';
import ProtectedRoute from './ProtectedRoute';
import { LoginServices } from '../services/LoginServices';
import HomePage from '../views/HomePage';

function RoutesIndex() {

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={LoginServices.verifySession() ? <Navigate to="/" replace /> : <LoginPage />} />
        <Route element={<ProtectedRoute />}>
          <Route path="/" element={<HomePage />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default RoutesIndex;